import script from "./ProfileInviteFriend.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileInviteFriend.vue?vue&type=script&setup=true&lang=js"

import "./ProfileInviteFriend.vue?vue&type=style&index=0&id=3336f662&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3336f662"]])

export default __exports__